module.exports = __webpack_public_path__ + "img/nav-design-modern.7008485.jpg";